import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { t } from 'c-3po';
import uuid from 'uuid';
import {
    getRoom,
    BESIDA_ROLE_COMPANY,
    MESSAGE_STATUS_DELIVERED,
    MESSAGE_STATUS_READ,
    MESSAGE_STATUS_NOT_DELIVERED,
    ERROR_TYPE_STOP_WORD,
    ERROR_TYPE_CAPS_LOCK
} from '@evo/chat-core';

import * as a from '../../../../../../../libs/actions';
import * as c from '../../../../../../../libs/constants';
import * as aggr from '../../../../../../../libs/aggregation';
import {
    humanizeChatDate,
    getUserName,
} from '../../../../../../../libs/helpers';
import {
    getCompanyManagersId,
    makeOrderLink,
} from '../../../../../../../libs/helpers/prom';
import {
    momentInCurrentTimeZone
} from '../../../../../../../libs/date';
import {
    isEmpty,
    getSocketStore,
    getMessageStatus,
} from '../../../../../../../libs/utils';

import { toJS } from '../../../../../../helpers/ImmutableToJS';

import { Icon } from '../../../../../../ui/icon';

import { Processing } from './../processing';

// styles
import css from './commonMessage.sss';

// images
import CheckIconSvg from './images/check.icon.svg';
import WarningIconSvg from './images/warning.icon.svg';


class CommonMsgView extends React.Component {

    static propTypes = {
        users: PropTypes.object,
        extra: PropTypes.object,
        firstUnreadMsgId: PropTypes.any,
        msgId: PropTypes.any,
        msg: PropTypes.object,
        isLastMsg: PropTypes.bool,
        messageStatus: PropTypes.string,
        intersectionObserver: PropTypes.object,
        lastReadMessageId: PropTypes.number,
        isOpenToolTip: PropTypes.bool,
        dialogOwner: PropTypes.any,
        newMsgMarkShown: PropTypes.any,
        markMsgRead: PropTypes.func,
        retrySendMsg: PropTypes.func,
        triggerScroll: PropTypes.func,
    };

    componentDidMount() {
        const { intersectionObserver } = this.props;
        this.urlSplitHash = uuid.v4().toUpperCase();

        this.newMessageMark && intersectionObserver.observe(this.newMessageMark);
    }

    componentDidUpdate() {
        const { isOpenToolTip, isLastUnsentMsg } = this.props;

        if (isOpenToolTip && isLastUnsentMsg) this.props.triggerScroll();
    }

    renderTextBreakTags(plainText) {
        if (!plainText) return plainText;

        const splittedText = plainText.split('\n');
        const splitArrLength = splittedText.length;

        if (splitArrLength === 1) return splittedText[0];

        return splittedText.map((textChank, i) => [
            textChank,
            splitArrLength - 1 === i ? null : <br />,
        ]);
    }

    renderClickableLinks(msgBody) {
        if (!msgBody) return msgBody;
        const matchedUrls = msgBody.match(c.URL_PATTERN);

        if (isEmpty(matchedUrls)) return this.renderTextBreakTags(msgBody);

        let replacedMsg = msgBody;

        matchedUrls.forEach((link) => {
            replacedMsg = replacedMsg.replace(link, this.urlSplitHash);
        });

        const splittedMsg = replacedMsg.split(this.urlSplitHash);
        const addProtocolIfNeeded = (url) => {
            if (url.slice(0, 4) !== 'www.') return url;
            return `http://${url}`;
        };

        return splittedMsg.map((stringPart, i) => {
            if (!matchedUrls[i]) return this.renderTextBreakTags(stringPart);
            return [
                this.renderTextBreakTags(stringPart),
                <a
                    href={addProtocolIfNeeded(matchedUrls[i])}
                    target='_blank'
                >{matchedUrls[i]}</a>,
            ];
        });
    }

    renderFilterErrors = () => {
        const { errors } = this.props;
        let errorText = t`o(╥﹏╥)o Что-то пошло не так`;
        if (ERROR_TYPE_STOP_WORD in errors) {
            errorText = t`Ваше сообщение содержит стоп-слова, оскорбления или бранную лексику.
                            Пожалуйста, напишите текст, используя нормативную лексику.`;
        } else if (ERROR_TYPE_CAPS_LOCK in errors) {
            errorText = t`Сообщение полностью написано ЗАГЛАВНЫМИ буквами (с использованием клавиши Caps Lock).
                            Пожалуйста, напишите текст, используя строчные буквы.`;
        }
        return errorText;
    }

    render() {
        const {
            users, msg, dialogOwner, currentChatRoom, isLastUnsentMsg, isOpenToolTip,
            firstUnreadMsgId, newMsgMarkShown, isNewCabinet, userRole, messageStatus,
            retrySendMsg
        } = this.props;

        const isInCompanyRole = userRole === BESIDA_ROLE_COMPANY;
        const companyManagers = getCompanyManagersId(currentChatRoom.users);

        const itemRight =
            dialogOwner === msg.user_ident ||
            (isInCompanyRole && companyManagers.includes(msg.user_ident));


        const showHint = isLastUnsentMsg && isOpenToolTip;

        return (
            <li
                className={itemRight ? css.rootTypeRight : css.root}
                data-qaid={users[msg.user_ident].role}
                key={`${msg.id}chatMsg`}
                {...{[isLastUnsentMsg ? `data-msg${msg.id}`.slice(0, 12) : 'data-none']: 'true'}}
                ref={(node) => {
                    if (isLastUnsentMsg) this.msgNode = node;
                    else this.msgNode = null;
                }}
            >
                {msg.id === Number(firstUnreadMsgId) && (
                    dialogOwner !== msg.user_ident) && (
                    <div
                        ref={(node) => { this.newMessageMark = node; }}
                        className={css.statusWrapper}
                    >
                        <span className={newMsgMarkShown ? css.statusNew : css.status}>
                            {t`Новое сообщение`}
                        </span>
                    </div>
                )}
                <div className={css.messageHolder}>
                    <div
                        className={css.message}
                        data-qaid='message_block'
                    >
                        <div className={css.name} data-qaid='name_field'>
                            {getUserName(users[msg.user_ident], this.props.extra)}{`: `}
                        </div>
                        <div data-qaid='msg_text' className={css.text}>
                            {msg.body ? this.renderClickableLinks(msg.body) : [
                                t`Заказ №`,
                                <a
                                    key={`${msg.context_item_id}chatOrderLink`}
                                    href={makeOrderLink(
                                    msg.context_item_id,
                                    isInCompanyRole ? c.INIT_POSITION_CABINET : c.INIT_POSITION_PORTAL,
                                    isNewCabinet)}
                                >
                                    {msg.context_item_id}
                                </a>,
                                t` успешно оформлен`
                            ]}
                        </div>
                        <div className={css.messageStatus}>
                            <span
                                className={css.date}
                                title={momentInCurrentTimeZone(msg.date_sent).format('HH:mm DD.MM.YYYY')}
                            >
                                {humanizeChatDate(msg.date_sent)}
                            </span>

                            {itemRight && (
                                <span className={css.statusIconHolder}>
                                    {messageStatus === MESSAGE_STATUS_DELIVERED && (
                                        <span title={t`Доставлено`}>
                                            <Icon
                                                className={css.statusIcon}
                                                glyph={CheckIconSvg}
                                            />
                                        </span>
                                    )}
                                    {messageStatus === MESSAGE_STATUS_READ && (
                                        <span title={t`Прочитано`}>
                                            <Icon
                                                className={css.statusIcon}
                                                glyph={CheckIconSvg}
                                            />
                                            <Icon
                                                className={css.statusIcon}
                                                glyph={CheckIconSvg}
                                            />
                                        </span>
                                    )}
                                    {messageStatus === MESSAGE_STATUS_NOT_DELIVERED && (
                                        <span title={t`Ошибка`}>
                                            <Icon
                                                className={css.statusIconRed}
                                                glyph={WarningIconSvg}
                                            />
                                        </span>
                                    )}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                <Processing
                    isSpellingError={msg.isSpellingError}
                    status={messageStatus}
                    retry={retrySendMsg}
                    msgId={msg.id}
                />
                {showHint && (
                    <div
                        className={css.errorHint}
                        data-qaid='hint_popup'
                    >
                        {this.renderFilterErrors()}
                    </div>
                )}
            </li>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));
    const currentChatHistory = currentChatRoom.get('history');
    const dialogOwner = aggr.getDialogOwner(state);


    const lastReadMessageId = currentChatRoom.get('last_read_counter');
    const firstUnreadMsg = currentChatHistory.find(
        (msg) => msg.get('id') > lastReadMessageId && !msg.get('context_item_id'));
    const lastUnsentMsg = currentChatHistory.findLast((msg) => msg.get('isTemporaryMessage'));
    const firstUnreadMsgId = firstUnreadMsg ? firstUnreadMsg.get('id') : '0';
    const msg = currentChatHistory.find((m) => m.get('id') === ownProps.msgId);
    const messageStatus = getMessageStatus(state, msg);

    return {
        users: currentChatRoom.get('users'),
        extra: currentChatRoom.get('extra'),
        newMsgMarkShown: state.get('newMsgMarkShown'),
        rerenderCounter: state.get('rerenderCounter'),
        newMsgInCurrentDialog: aggr.newMsgInCurrentDialog(currentChatRoom),
        isOpenToolTip: state.getIn(['isOpen', 'dialogToolTip']),
        isNewCabinet: state.get('isNewCabinet'),
        isLastUnsentMsg: lastUnsentMsg && lastUnsentMsg.get('id') === msg.get('id'),
        errors: state.get('errors'),
        userRole: state.get('userRole'),
        locale: state.get('locale'),
        dialogOwner,
        currentChatRoom,
        firstUnreadMsgId,
        lastReadMessageId,
        messageStatus,
        msg
    };
};

export const CommonMsg = connect(mapStateToProps)(toJS(CommonMsgView));
